import http from 'core/services/http';
import Config from 'core/config';
import {isEmpty, isObject} from 'lodash';
import { toQueryString } from 'shared/helpers';

class NotificationsService {
  static getNotifications(userId, params) {
    const queryString = params && isObject(params) ? `?${toQueryString(params)}` : '';
    return http.get(`${Config.apiUrl}/personnel/${userId}/notifications${queryString}`);
  }

  static getNotificationsCount(userId, status) {
    return http.get(`${Config.apiUrl}/personnel/${userId}/notificationscount?status=${status}`);
  }

  static addNotification(userId, data) {
    return http.post(`${Config.apiUrl}/personnel/${userId}/notifications`, data);
  }

  static setNotificationAsRead(userId, data) {
    return http.post(`${Config.apiUrl}/personnel/${userId}/marknotificationasread`, data);
  }

  static getTemplateParams(userId) {
    return http.get(`${Config.apiUrl}/personnel/${userId}/tempalteparams`);
  }
}

export default NotificationsService;
